(function () {
  const DESKTOP_WIDTH = 1280;
  const MOBILE_WIDTH = 760;
  const HEIGHT = 720;
  const GROUND = 578;
  const BASE_SPEED = 370;
  const MAX_SPEED = 700;
  const GRAVITY = 2200;
  const JUMP_FORCE = -990;
  const FAST_FALL_SPEED = 1120;
  const MUSIC_STEP_DURATION = 0.18;
  const MUSIC_PHRASE_ORDER = [0, 1, 0, 2, 3, 1, 4, 2, 5, 0, 6, 3, 7, 6, 4, 7];
  const MUSIC_PHRASES = [
    [293.66, 311.13, 369.99, 392, 440, 392, 369.99, 311.13, 293.66, 293.66, 349.23, 392, 369.99, 311.13, 277.18, 293.66, 0, 220],
    [440, 466.16, 554.37, 587.33, 659.25, 587.33, 554.37, 466.16, 440, 392, 440, 466.16, 554.37, 523.25, 466.16, 440, 392, 0],
    [293.66, 311.13, 369.99, 440, 392, 369.99, 311.13, 293.66, 277.18, 293.66, 369.99, 392, 440, 466.16, 440, 392, 369.99, 0],
    [587.33, 554.37, 466.16, 440, 392, 369.99, 311.13, 293.66, 0, 369.99, 392, 440, 466.16, 554.37, 466.16, 440, 392, 369.99],
    [293.66, 369.99, 392, 440, 0, 440, 466.16, 554.37, 587.33, 554.37, 466.16, 440, 392, 369.99, 311.13, 293.66, 277.18, 0],
    [220, 233.08, 277.18, 293.66, 369.99, 293.66, 277.18, 233.08, 220, 293.66, 311.13, 369.99, 392, 440, 392, 369.99, 311.13, 0],
    [440, 554.37, 587.33, 659.25, 587.33, 554.37, 466.16, 440, 392, 369.99, 392, 440, 466.16, 440, 392, 369.99, 311.13, 293.66],
    [293.66, 311.13, 369.99, 392, 440, 466.16, 554.37, 587.33, 659.25, 587.33, 554.37, 466.16, 440, 392, 369.99, 311.13, 293.66, 0]
  ];
  const MUSIC_BASS = [146.83, 146.83, 174.61, 138.59, 146.83, 196, 174.61, 138.59];

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function randomBetween(min, max) {
    return min + Math.random() * (max - min);
  }

  function paddedScore(value) {
    return String(Math.max(0, Math.floor(value))).padStart(5, "0");
  }

  function intersects(a, b) {
    return a.x < b.x + b.w && a.x + a.w > b.x && a.y < b.y + b.h && a.y + a.h > b.y;
  }

  function loadImage(url) {
    return new Promise(function (resolve, reject) {
      const image = new Image();
      image.decoding = "async";
      image.onload = function () { resolve(image); };
      image.onerror = reject;
      image.src = url;
    });
  }

  function initRunner(root) {
    if (root.dataset.runnerReady === "true") return;
    root.dataset.runnerReady = "true";

    const canvas = root.querySelector("[data-game-canvas]");
    const context = canvas.getContext("2d");
    const assetNode = root.querySelector("[data-hatton-assets]");
    const scoreNode = root.querySelector("[data-score]");
    const scoreGainNode = root.querySelector("[data-score-gain]");
    const bestNode = root.querySelector("[data-best]");
    const speedNode = root.querySelector("[data-speed]");
    const audioToggle = root.querySelector("[data-audio-toggle]");
    const audioLabel = root.querySelector("[data-audio-label]");
    const finalScoreNode = root.querySelector("[data-final-score]");
    const statusNode = root.querySelector("[data-game-status]");
    const startScreen = root.querySelector("[data-start-screen]");
    const loadingScreen = root.querySelector("[data-loading-screen]");
    const gameOverScreen = root.querySelector("[data-game-over-screen]");
    const startButton = root.querySelector("[data-start-button]");
    const restartButton = root.querySelector("[data-restart-button]");
    const scoreForm = root.querySelector("[data-score-form]");
    const formMessage = root.querySelector("[data-form-message]");
    const leaderboardNode = root.querySelector("[data-leaderboard]");
    const leaderboardSection = root.querySelector("[data-leaderboard-section]");
    const assetUrls = JSON.parse(assetNode.textContent);
    const images = {};
    const sessionScores = [];
    const mobileMode = window.matchMedia("(max-width: 760px)").matches;
    const worldWidth = mobileMode ? MOBILE_WIDTH : DESKTOP_WIDTH;

    canvas.width = worldWidth;
    root.classList.toggle("is-mobile-game", mobileMode);

    let state = "idle";
    let animationFrame = 0;
    let previousTime = 0;
    let elapsed = 0;
    let distance = 0;
    let bonusScore = 0;
    let score = 0;
    let bestScore = 0;
    let speed = BASE_SPEED;
    let backgroundOffset = 0;
    let platformOffset = 0;
    let obstacleTimer = 1.35;
    let collectibleTimer = 0.8;
    let objects = [];
    let duckPressed = false;
    let fastFalling = false;
    let assetsReady = false;
    let audioContext = null;
    let musicGain = null;
    let effectsGain = null;
    let musicTimer = 0;
    let nextMusicNote = 0;
    let musicStep = 0;
    let scoreGainTimer = 0;
    let audioEnabled = true;
    let gesturePointerId = null;
    let gestureStartX = 0;
    let gestureStartY = 0;

    const player = {
      x: mobileMode ? 116 : 175,
      y: GROUND - 124,
      vy: 0,
      onGround: true,
      crouching: false,
      frameClock: 0,
      frame: 0
    };

    context.imageSmoothingEnabled = false;

    function getPlayerBox() {
      if (player.crouching && player.onGround) {
        return { x: player.x + 8, y: GROUND - 72, w: 72, h: 62 };
      }
      if (!player.onGround) {
        return { x: player.x + 12, y: player.y + 8, w: 66, h: 96 };
      }
      return { x: player.x + 8, y: GROUND - 150, w: 68, h: 138 };
    }

    function announce(message) {
      statusNode.textContent = "";
      window.setTimeout(function () { statusNode.textContent = message; }, 20);
    }

    function ensureAudio() {
      const AudioContextClass = window.AudioContext || window.webkitAudioContext;
      if (!AudioContextClass) {
        audioToggle.hidden = true;
        return null;
      }
      if (!audioContext) {
        audioContext = new AudioContextClass();
        musicGain = audioContext.createGain();
        effectsGain = audioContext.createGain();
        musicGain.gain.value = 0;
        effectsGain.gain.value = 0.18;
        musicGain.connect(audioContext.destination);
        effectsGain.connect(audioContext.destination);
      }
      if (audioContext.state === "suspended") audioContext.resume();
      return audioContext;
    }

    function playTone(destination, frequency, start, duration, type, volume) {
      if (!audioContext || !destination) return;
      const oscillator = audioContext.createOscillator();
      const gain = audioContext.createGain();
      oscillator.type = type;
      oscillator.frequency.setValueAtTime(frequency, start);
      gain.gain.setValueAtTime(0.0001, start);
      gain.gain.exponentialRampToValueAtTime(volume, start + 0.018);
      gain.gain.exponentialRampToValueAtTime(0.0001, start + duration);
      oscillator.connect(gain);
      gain.connect(destination);
      oscillator.start(start);
      oscillator.stop(start + duration + 0.03);
    }

    function playNoiseBurst(start, duration, frequency, volume) {
      if (!audioContext || !effectsGain) return;
      const frameCount = Math.max(1, Math.floor(audioContext.sampleRate * duration));
      const buffer = audioContext.createBuffer(1, frameCount, audioContext.sampleRate);
      const channel = buffer.getChannelData(0);
      for (let index = 0; index < frameCount; index += 1) {
        channel[index] = (Math.random() * 2 - 1) * (1 - index / frameCount);
      }
      const source = audioContext.createBufferSource();
      const filter = audioContext.createBiquadFilter();
      const gain = audioContext.createGain();
      source.buffer = buffer;
      filter.type = "lowpass";
      filter.frequency.setValueAtTime(frequency, start);
      gain.gain.setValueAtTime(volume, start);
      gain.gain.exponentialRampToValueAtTime(0.0001, start + duration);
      source.connect(filter);
      filter.connect(gain);
      gain.connect(effectsGain);
      source.start(start);
    }

    function playVocalEffort(kind) {
      if (!audioEnabled) return;
      const contextNode = ensureAudio();
      if (!contextNode || !effectsGain) return;
      const start = contextNode.currentTime;
      const duration = kind === "jump" ? 0.42 : 0.3;
      const oscillator = contextNode.createOscillator();
      const formant = contextNode.createBiquadFilter();
      const gain = contextNode.createGain();
      oscillator.type = "sawtooth";
      formant.type = "bandpass";
      formant.Q.setValueAtTime(1.25, start);
      if (kind === "jump") {
        oscillator.frequency.setValueAtTime(112, start);
        oscillator.frequency.exponentialRampToValueAtTime(168, start + 0.13);
        oscillator.frequency.exponentialRampToValueAtTime(78, start + duration);
        formant.frequency.setValueAtTime(610, start);
        formant.frequency.exponentialRampToValueAtTime(920, start + 0.14);
        formant.frequency.exponentialRampToValueAtTime(470, start + duration);
      } else {
        oscillator.frequency.setValueAtTime(176, start);
        oscillator.frequency.exponentialRampToValueAtTime(132, start + 0.14);
        oscillator.frequency.exponentialRampToValueAtTime(108, start + duration);
        formant.frequency.setValueAtTime(880, start);
        formant.frequency.exponentialRampToValueAtTime(620, start + duration);
      }
      gain.gain.setValueAtTime(0.0001, start);
      gain.gain.exponentialRampToValueAtTime(kind === "jump" ? 0.115 : 0.09, start + 0.04);
      gain.gain.exponentialRampToValueAtTime(0.0001, start + duration);
      oscillator.connect(formant);
      formant.connect(gain);
      gain.connect(effectsGain);
      oscillator.start(start);
      oscillator.stop(start + duration + 0.02);
      playNoiseBurst(start, duration, kind === "jump" ? 820 : 680, kind === "jump" ? 0.025 : 0.018);
    }

    function playFootstepSound() {
      if (!audioEnabled || !player.onGround || player.crouching) return;
      const contextNode = ensureAudio();
      if (!contextNode) return;
      const start = contextNode.currentTime;
      playTone(effectsGain, 72, start, 0.065, "sine", 0.045);
      playNoiseBurst(start, 0.055, 240, 0.035);
    }

    function scheduleMusic() {
      if (!audioEnabled || state !== "running" || !audioContext || document.hidden) return;
      while (nextMusicNote < audioContext.currentTime + 0.35) {
        const phraseLength = MUSIC_PHRASES[0].length;
        const phrasePosition = Math.floor(musicStep / phraseLength) % MUSIC_PHRASE_ORDER.length;
        const phrase = MUSIC_PHRASES[MUSIC_PHRASE_ORDER[phrasePosition]];
        const phraseStep = musicStep % phraseLength;
        const barStep = musicStep % 9;
        const frequency = phrase[phraseStep];
        const strongBeat = barStep === 0 || barStep === 6;
        const accentBeat = barStep === 2 || barStep === 4;
        if (frequency) {
          playTone(musicGain, frequency, nextMusicNote, strongBeat ? 0.2 : 0.145, "square", strongBeat ? 0.065 : 0.05);
        }
        if (strongBeat || accentBeat) {
          const bassIndex = Math.floor(musicStep / 9) % MUSIC_BASS.length;
          playTone(musicGain, MUSIC_BASS[bassIndex], nextMusicNote, strongBeat ? 0.3 : 0.2, "triangle", strongBeat ? 0.085 : 0.045);
          playTone(musicGain, strongBeat ? 82.41 : 164.81, nextMusicNote, strongBeat ? 0.11 : 0.055, "sine", strongBeat ? 0.12 : 0.045);
        }
        musicStep += 1;
        nextMusicNote += MUSIC_STEP_DURATION;
      }
      musicTimer = window.setTimeout(scheduleMusic, 120);
    }

    function startMusic() {
      const contextNode = ensureAudio();
      if (!contextNode || !audioEnabled) return;
      window.clearTimeout(musicTimer);
      musicGain.gain.cancelScheduledValues(contextNode.currentTime);
      musicGain.gain.setTargetAtTime(0.18, contextNode.currentTime, 0.04);
      nextMusicNote = contextNode.currentTime + 0.05;
      scheduleMusic();
    }

    function stopMusic() {
      window.clearTimeout(musicTimer);
      musicTimer = 0;
      if (!audioContext || !musicGain) return;
      musicGain.gain.cancelScheduledValues(audioContext.currentTime);
      musicGain.gain.setTargetAtTime(0.0001, audioContext.currentTime, 0.035);
    }

    function playCollectibleSound() {
      const contextNode = ensureAudio();
      if (!contextNode || !audioEnabled) return;
      const start = contextNode.currentTime;
      playTone(effectsGain, 659.25, start, 0.06, "square", 0.11);
      playTone(effectsGain, 987.77, start + 0.045, 0.085, "square", 0.085);
    }

    function updateAudioButton() {
      audioToggle.setAttribute("aria-pressed", String(audioEnabled));
      audioToggle.setAttribute("aria-label", audioEnabled ? "Oyun sesini kapat" : "Oyun sesini aç");
      audioLabel.textContent = audioEnabled ? "SES AÇIK" : "SES KAPALI";
    }

    function toggleAudio() {
      audioEnabled = !audioEnabled;
      updateAudioButton();
      if (!audioEnabled) {
        stopMusic();
        return;
      }
      ensureAudio();
      if (state === "running") startMusic();
    }

    function showScoreGain(amount) {
      window.clearTimeout(scoreGainTimer);
      scoreGainNode.querySelector("b").textContent = "+" + amount;
      scoreGainNode.classList.remove("is-visible");
      void scoreGainNode.offsetWidth;
      scoreGainNode.classList.add("is-visible");
      scoreGainTimer = window.setTimeout(function () {
        scoreGainNode.classList.remove("is-visible");
      }, 920);
    }

    function showOnly(screen) {
      [startScreen, loadingScreen, gameOverScreen].forEach(function (node) {
        node.classList.toggle("is-visible", node === screen);
      });
    }

    function resetGame() {
      elapsed = 0;
      distance = 0;
      bonusScore = 0;
      score = 0;
      speed = BASE_SPEED;
      backgroundOffset = 0;
      platformOffset = 0;
      obstacleTimer = 1.25;
      collectibleTimer = 0.9;
      objects = [];
      duckPressed = false;
      fastFalling = false;
      player.y = GROUND - 124;
      player.vy = 0;
      player.onGround = true;
      player.crouching = false;
      player.frameClock = 0;
      player.frame = 0;
      musicStep = 0;
      scoreNode.textContent = paddedScore(0);
      speedNode.textContent = "1.0×";
      scoreGainNode.classList.remove("is-visible");
      formMessage.textContent = "";
      formMessage.classList.remove("is-success");
      scoreForm.reset();
      scoreForm.querySelectorAll("input").forEach(function (input) {
        input.removeAttribute("aria-invalid");
      });
      scoreForm.querySelector("button[type='submit']").disabled = false;
    }

    function startGame() {
      if (!assetsReady) {
        showOnly(loadingScreen);
        return;
      }
      resetGame();
      state = "running";
      showOnly(null);
      previousTime = performance.now();
      announce("Koşu başladı");
      if (audioEnabled) startMusic();
      cancelAnimationFrame(animationFrame);
      animationFrame = requestAnimationFrame(loop);
    }

    function jump() {
      if (state !== "running" || !player.onGround) return;
      player.vy = JUMP_FORCE;
      player.onGround = false;
      player.crouching = false;
      fastFalling = false;
      playVocalEffort("jump");
      announce("Zıpladın");
    }

    function setDuck(value) {
      const wasDuckPressed = duckPressed;
      duckPressed = value;
      if (state !== "running") return;
      if (!player.onGround && value) {
        fastFalling = true;
        player.vy = Math.max(player.vy, FAST_FALL_SPEED);
        announce("Hızlı iniyorsun");
        return;
      }
      if (player.onGround) {
        player.crouching = value;
        if (value && !wasDuckPressed) playVocalEffort("duck");
      }
    }

    function endGame() {
      if (state !== "running") return;
      state = "over";
      bestScore = Math.max(bestScore, score);
      bestNode.textContent = paddedScore(bestScore);
      finalScoreNode.textContent = paddedScore(score);
      stopMusic();
      showOnly(gameOverScreen);
      announce("Koşu bitti. Skorun " + score + " puan.");
      window.setTimeout(function () {
        const firstInput = scoreForm.querySelector("input[name='firstName']");
        if (firstInput) firstInput.focus();
      }, 80);
    }

    function createJumpObstacle(index) {
      const variants = [
        { drawW: 150, drawH: 75, drawY: GROUND - 63, boxX: 20, boxY: GROUND - 36, boxW: 108, boxH: 27 },
        { drawW: 150, drawH: 150, drawY: GROUND - 144, boxX: 30, boxY: GROUND - 112, boxW: 90, boxH: 102 },
        { drawW: 126, drawH: 126, drawY: GROUND - 116, boxX: 17, boxY: GROUND - 84, boxW: 92, boxH: 75 }
      ];
      const variant = variants[index];
      return {
        type: "obstacle",
        action: "jump",
        image: images.jumpObstacles[index],
        x: worldWidth + 90,
        y: variant.boxY,
        w: variant.boxW,
        h: variant.boxH,
        boxX: variant.boxX,
        drawW: variant.drawW,
        drawH: variant.drawH,
        drawY: variant.drawY,
        passed: false
      };
    }

    function createDuckObstacle(index) {
      const variants = [
        {
          drawW: 460,
          drawH: 288,
          drawY: GROUND - 274,
          boxX: 112,
          boxY: GROUND - 190,
          boxW: 286,
          boxH: 105,
          baseSlices: [
            { x: 0, y: 0, w: 600, h: 640 },
            { x: 600, y: 0, w: 424, h: 70 },
            { x: 875, y: 70, w: 149, h: 570 }
          ],
          frontSlices: [
            { x: 600, y: 70, w: 275, h: 570, dy: 70, dh: 748 }
          ]
        },
        {
          drawW: 480,
          drawH: 300,
          drawY: GROUND - 285,
          boxX: 82,
          boxY: GROUND - 190,
          boxW: 330,
          boxH: 100,
          baseSlices: [
            { x: 0, y: 0, w: 740, h: 295 },
            { x: 910, y: 0, w: 114, h: 640 },
            { x: 0, y: 295, w: 130, h: 345 },
            { x: 250, y: 295, w: 490, h: 345 },
            { x: 130, y: 295, w: 120, h: 195, dy: 295, dh: 276 },
            { x: 130, y: 490, w: 120, h: 37, dy: 571, dh: 37 }
          ],
          frontSlices: [
            { x: 220, y: 105, w: 530, h: 330 },
            { x: 740, y: 25, w: 170, h: 615, dy: 25, dh: 784 }
          ]
        }
      ];
      const variant = variants[index];
      return {
        type: "obstacle",
        action: "duck",
        image: images.duckObstacles[index],
        x: worldWidth + 90,
        y: variant.boxY,
        w: variant.boxW,
        h: variant.boxH,
        boxX: variant.boxX,
        drawW: variant.drawW,
        drawH: variant.drawH,
        drawY: variant.drawY,
        baseSlices: variant.baseSlices,
        frontSlices: variant.frontSlices,
        passed: false
      };
    }

    function spawnObstacle() {
      const makeDuck = elapsed > 12 && Math.random() < 0.3;
      if (makeDuck) {
        const index = Math.floor(Math.random() * images.duckObstacles.length);
        objects.push(createDuckObstacle(index));
      } else {
        const index = Math.floor(Math.random() * images.jumpObstacles.length);
        objects.push(createJumpObstacle(index));
      }
    }

    function spawnCollectible() {
      const heights = [GROUND - 142, GROUND - 224, GROUND - 306];
      const index = Math.floor(Math.random() * images.collectibles.length);
      const y = heights[Math.floor(Math.random() * heights.length)];
      objects.push({
        type: "collectible",
        image: images.collectibles[index],
        x: worldWidth + 70,
        y: y,
        w: 58,
        h: 58,
        drawW: 76,
        drawH: 76,
        phase: Math.random() * Math.PI * 2,
        collected: false
      });
    }

    function update(dt) {
      elapsed += dt;
      speed = Math.min(MAX_SPEED, BASE_SPEED + elapsed * 2.8);
      const worldStep = speed * dt;
      distance += worldStep;
      backgroundOffset += worldStep * 0.12;
      platformOffset += worldStep;

      if (!player.onGround) {
        player.vy += GRAVITY * (fastFalling ? 1.65 : 1) * dt;
        player.y += player.vy * dt;
        if (player.y >= GROUND - 124) {
          player.y = GROUND - 124;
          player.vy = 0;
          player.onGround = true;
          fastFalling = false;
          player.crouching = duckPressed;
        }
      } else {
        player.crouching = duckPressed;
      }

      player.frameClock += dt;
      const frameDuration = player.crouching ? 0.13 : 0.1;
      if (player.frameClock >= frameDuration) {
        player.frameClock -= frameDuration;
        player.frame = (player.frame + 1) % 3;
        if (player.frame === 0 || player.frame === 2) playFootstepSound();
      }

      obstacleTimer -= dt;
      if (obstacleTimer <= 0) {
        spawnObstacle();
        const pace = clamp(2.2 - (speed - BASE_SPEED) / 620, 1.35, 2.2);
        obstacleTimer = randomBetween(pace, pace + 0.9);
      }

      collectibleTimer -= dt;
      if (collectibleTimer <= 0) {
        spawnCollectible();
        collectibleTimer = randomBetween(1.45, 2.8);
      }

      const playerBox = getPlayerBox();
      objects.forEach(function (object) {
        object.x -= worldStep;
        if (object.type === "collectible") {
          object.phase += dt * 6;
          const box = { x: object.x + 2, y: object.y + 2, w: object.w - 4, h: object.h - 4 };
          if (!object.collected && intersects(playerBox, box)) {
            object.collected = true;
            bonusScore += 150;
            playCollectibleSound();
            showScoreGain(150);
            announce("Nesne topladın, 150 puan");
          }
          return;
        }

        const obstacleBox = {
          x: object.x + (object.boxX || 0),
          y: object.y,
          w: object.w,
          h: object.h
        };
        if (intersects(playerBox, obstacleBox)) endGame();
      });

      objects = objects.filter(function (object) {
        return object.x + (object.drawW || object.w) > -40 && !object.collected;
      });

      score = Math.floor(distance / 42) + bonusScore;
      scoreNode.textContent = paddedScore(score);
      speedNode.textContent = (speed / BASE_SPEED).toFixed(1) + "×";
    }

    function drawBackground() {
      const background = images.background;
      const scaledWidth = background.width * (HEIGHT / background.height);
      const offset = backgroundOffset % scaledWidth;
      let tileIndex = Math.floor(backgroundOffset / scaledWidth);
      for (let x = -offset; x < worldWidth; x += scaledWidth) {
        if (tileIndex % 2 === 0) {
          context.drawImage(background, x, 0, scaledWidth + 1, HEIGHT);
        } else {
          context.save();
          context.translate(x + scaledWidth + 1, 0);
          context.scale(-1, 1);
          context.drawImage(background, 0, 0, scaledWidth + 1, HEIGHT);
          context.restore();
        }
        tileIndex += 1;
      }

      const platform = images.platform;
      const platformHeight = 182;
      const platformWidth = platform.width * (platformHeight / platform.height);
      const platformY = GROUND - 13;
      const groundOffset = platformOffset % platformWidth;
      for (let x = -groundOffset; x < worldWidth; x += platformWidth) {
        context.drawImage(platform, x, platformY, platformWidth + 1, platformHeight);
      }
    }

    function drawPlayer() {
      if (!player.onGround) {
        context.drawImage(images.jump, player.x - 50, player.y - 38, 205, 205);
        return;
      }

      const sheet = player.crouching ? images.crouch : images.run;
      const frameWidth = sheet.width / 3;
      if (player.crouching) {
        context.drawImage(sheet, player.frame * frameWidth, 0, frameWidth, sheet.height, player.x - 50, GROUND - 164, 205, 205);
      } else {
        context.drawImage(sheet, player.frame * frameWidth, 0, frameWidth, sheet.height, player.x - 50, GROUND - 202, 205, 205);
      }
    }

    function drawObjectSlices(object, slices) {
      const scaleX = object.drawW / object.image.width;
      const scaleY = object.drawH / object.image.height;
      slices.forEach(function (slice) {
        const dx = typeof slice.dx === "number" ? slice.dx : slice.x;
        const dy = typeof slice.dy === "number" ? slice.dy : slice.y;
        const dw = typeof slice.dw === "number" ? slice.dw : slice.w;
        const dh = typeof slice.dh === "number" ? slice.dh : slice.h;
        context.drawImage(
          object.image,
          slice.x,
          slice.y,
          slice.w,
          slice.h,
          object.x + dx * scaleX,
          object.drawY + dy * scaleY,
          dw * scaleX,
          dh * scaleY
        );
      });
    }

    function drawObjectsBehindPlayer() {
      objects.forEach(function (object) {
        if (object.type === "collectible") {
          const bob = Math.sin(object.phase) * 7;
          context.save();
          context.shadowColor = "rgba(255, 231, 112, 0.9)";
          context.shadowBlur = 20;
          context.drawImage(object.image, object.x - 9, object.y - 9 + bob, object.drawW, object.drawH);
          context.restore();
        } else if (object.action === "duck" && object.baseSlices) {
          drawObjectSlices(object, object.baseSlices);
        } else {
          context.drawImage(object.image, object.x, object.drawY, object.drawW, object.drawH);
        }
      });
    }

    function drawDuckObstaclesInFront() {
      objects.forEach(function (object) {
        if (object.type !== "obstacle" || object.action !== "duck") return;
        drawObjectSlices(object, object.frontSlices);
      });
    }

    function draw() {
      context.clearRect(0, 0, worldWidth, HEIGHT);
      drawBackground();
      drawObjectsBehindPlayer();
      drawPlayer();
      drawDuckObstaclesInFront();
    }

    function loop(time) {
      if (state !== "running") return;
      const dt = Math.min((time - previousTime) / 1000, 0.034);
      previousTime = time;
      update(dt);
      draw();
      if (state === "running") animationFrame = requestAnimationFrame(loop);
    }

    function drawIdle() {
      if (!assetsReady) return;
      context.clearRect(0, 0, worldWidth, HEIGHT);
      drawBackground();
      drawPlayer();
    }

    function renderLeaderboard() {
      leaderboardNode.innerHTML = "";
      if (!sessionScores.length) {
        const item = document.createElement("li");
        const name = document.createElement("span");
        const value = document.createElement("b");
        name.textContent = "Henüz kayıt yok";
        value.textContent = "—";
        item.append(name, value);
        leaderboardNode.append(item);
        return;
      }

      sessionScores.slice(0, 5).forEach(function (entry) {
        const item = document.createElement("li");
        const name = document.createElement("span");
        const value = document.createElement("b");
        name.textContent = entry.name;
        value.textContent = entry.score;
        item.append(name, value);
        leaderboardNode.append(item);
      });
    }

    function validateForm() {
      const firstNameInput = scoreForm.querySelector("input[name='firstName']");
      const lastNameInput = scoreForm.querySelector("input[name='lastName']");
      const emailInput = scoreForm.querySelector("input[name='email']");
      const consentInput = scoreForm.querySelector("input[name='marketingConsent']");
      const firstNameValid = firstNameInput.value.trim().length >= 2;
      const lastNameValid = lastNameInput.value.trim().length >= 2;
      const emailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailInput.value.trim());
      const consentValid = consentInput.checked;
      firstNameInput.setAttribute("aria-invalid", String(!firstNameValid));
      lastNameInput.setAttribute("aria-invalid", String(!lastNameValid));
      emailInput.setAttribute("aria-invalid", String(!emailValid));
      consentInput.setAttribute("aria-invalid", String(!consentValid));
      if (!firstNameValid) {
        formMessage.textContent = "Lütfen ismini gir.";
        firstNameInput.focus();
        return false;
      }
      if (!lastNameValid) {
        formMessage.textContent = "Lütfen soyismini gir.";
        lastNameInput.focus();
        return false;
      }
      if (!emailValid) {
        formMessage.textContent = "Geçerli bir e-posta adresi gir.";
        emailInput.focus();
        return false;
      }
      if (!consentValid) {
        formMessage.textContent = "Skorunu kaydetmek için e-posta izni kutusunu onaylamalısın.";
        consentInput.focus();
        return false;
      }
      return true;
    }

    function submitScore(event) {
      event.preventDefault();
      formMessage.classList.remove("is-success");
      if (!validateForm()) return;

      const firstName = scoreForm.elements.firstName.value.trim();
      const lastName = scoreForm.elements.lastName.value.trim();
      const email = scoreForm.elements.email.value.trim();
      const marketingConsent = scoreForm.elements.marketingConsent.checked;
      const payload = {
        firstName: firstName,
        lastName: lastName,
        email: email,
        marketingConsent: marketingConsent,
        score: score,
        submittedAt: new Date().toISOString()
      };

      root.dispatchEvent(new CustomEvent("hatton:leaderboard-submit", {
        bubbles: true,
        detail: payload
      }));

      sessionScores.push({ name: firstName + " " + lastName, score: score });
      sessionScores.sort(function (a, b) { return b.score - a.score; });
      renderLeaderboard();
      leaderboardSection.hidden = false;
      scoreForm.elements.email.value = "";
      formMessage.textContent = "Skor bu oturumun tablosuna eklendi. Veritabanı bağlantısı sonraki aşamada etkinleşecek.";
      formMessage.classList.add("is-success");
      scoreForm.querySelector("button[type='submit']").disabled = true;
      window.setTimeout(function () {
        leaderboardSection.scrollIntoView({ behavior: "smooth", block: "nearest" });
      }, 220);
    }

    function handleKeydown(event) {
      const target = event.target;
      if (target instanceof HTMLInputElement || target instanceof HTMLTextAreaElement) return;
      if (["ArrowUp", "ArrowDown", "KeyM"].includes(event.code)) event.preventDefault();
      if (event.repeat && event.code !== "ArrowDown") return;
      if (event.code === "KeyM") toggleAudio();
      if (event.code === "ArrowUp") jump();
      if (event.code === "ArrowDown") setDuck(true);
    }

    function handleKeyup(event) {
      if (event.code === "ArrowDown") setDuck(false);
    }

    function handleGestureStart(event) {
      if (event.pointerType !== "touch" || state !== "running") return;
      event.preventDefault();
      gesturePointerId = event.pointerId;
      gestureStartX = event.clientX;
      gestureStartY = event.clientY;
      canvas.setPointerCapture(event.pointerId);
    }

    function handleGestureEnd(event) {
      if (event.pointerId !== gesturePointerId) return;
      event.preventDefault();
      const deltaX = event.clientX - gestureStartX;
      const deltaY = event.clientY - gestureStartY;
      const verticalDistance = Math.abs(deltaY);
      const horizontalDistance = Math.abs(deltaX);
      gesturePointerId = null;
      if (verticalDistance < 28 && horizontalDistance < 28) {
        setDuck(false);
        announce("Normal koşuya döndün");
        return;
      }
      if (verticalDistance <= horizontalDistance || verticalDistance < 34) return;
      if (deltaY < 0) {
        setDuck(false);
        jump();
        return;
      }
      setDuck(true);
    }

    function cancelGesture(event) {
      if (event.pointerId === gesturePointerId) gesturePointerId = null;
    }

    startButton.addEventListener("click", startGame);
    restartButton.addEventListener("click", startGame);
    audioToggle.addEventListener("click", toggleAudio);
    scoreForm.addEventListener("submit", submitScore);
    canvas.addEventListener("pointerdown", handleGestureStart);
    canvas.addEventListener("pointerup", handleGestureEnd);
    canvas.addEventListener("pointercancel", cancelGesture);
    window.addEventListener("keydown", handleKeydown, { passive: false });
    window.addEventListener("keyup", handleKeyup);

    document.addEventListener("visibilitychange", function () {
      if (document.hidden) {
        stopMusic();
        return;
      }
      if (state === "running") {
        previousTime = performance.now();
        if (audioEnabled) startMusic();
      }
    });

    const flatUrls = [
      ["background", assetUrls.background],
      ["platform", assetUrls.platform],
      ["run", assetUrls.run],
      ["crouch", assetUrls.crouch],
      ["jump", assetUrls.jump]
    ];

    showOnly(loadingScreen);
    updateAudioButton();
    Promise.all(flatUrls.map(function (entry) { return loadImage(entry[1]); }))
      .then(function (loaded) {
        loaded.forEach(function (image, index) { images[flatUrls[index][0]] = image; });
        return Promise.all([
          Promise.all(assetUrls.collectibles.map(loadImage)),
          Promise.all(assetUrls.jumpObstacles.map(loadImage)),
          Promise.all(assetUrls.duckObstacles.map(loadImage))
        ]);
      })
      .then(function (groups) {
        images.collectibles = groups[0];
        images.jumpObstacles = groups[1];
        images.duckObstacles = groups[2];
        assetsReady = true;
        showOnly(startScreen);
        drawIdle();
      })
      .catch(function () {
        state = "error";
        loadingScreen.querySelector("p").textContent = "Oyun görselleri yüklenemedi. Lütfen sayfayı yenile.";
        showOnly(loadingScreen);
      });
  }

  function initializeAll() {
    document.querySelectorAll("[data-hatton-runner]").forEach(initRunner);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeAll, { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener("shopify:section:load", initializeAll);
})();
